import React, { useState, useEffect } from 'react';
import './MemoryCarousel.css';

const MemoryCarousel = ({ notes, onClose, initialNoteIndex, onPhotoOpen}) => {
  const [currentNoteIndex, setCurrentNoteIndex] = useState(initialNoteIndex);
  const [explosionImages, setExplosionImages] = useState([]);

  useEffect(() => {
    if (notes[currentNoteIndex]?.photoBase64) {
      const numPieces = 30;
      const newPieces = [];
      
      for (let i = 0; i < numPieces; i++) {
        const randomX = Math.random() * window.innerWidth;
        const randomDelay = Math.random() * 2;
        const randomDuration = 2 + Math.random() * 2;
        const randomScale = 0.5 + Math.random() * 0.5;
        
        newPieces.push({
          id: i,
          startX: randomX,
          delay: randomDelay,
          duration: randomDuration,
          scale: randomScale
        });
      }
      
      setExplosionImages(newPieces);
      const timer = setTimeout(() => setExplosionImages([]), 8000);
      return () => clearTimeout(timer);
    }
  }, [currentNoteIndex, notes]);

  const nextNote = () => {
    setCurrentNoteIndex((prevIndex) => (prevIndex + 1) % notes.length);
  };

  const previousNote = () => {
    setCurrentNoteIndex((prevIndex) =>
      prevIndex === 0 ? notes.length - 1 : prevIndex - 1
    );
  };

  return (
      <div className="memory-carousel" onClick={onClose}>
        <div 
          className="carousel-content" 
          onClick={(e) => e.stopPropagation()}
        >
          {notes.length > 0 ? (
            <>
              <div className="memory-card">
                <div className="memory-content">
                  <h3>{notes[currentNoteIndex]?.name}</h3>
                  <p>{notes[currentNoteIndex]?.content}</p>
                </div>
              </div>
              <div className="carousel-navigation">
                <button onClick={previousNote}>◀ Previous</button>
                <button onClick={nextNote}>Next ▶</button>
              </div>
            </>
          ) : (
            <p>No memories added yet</p>
          )}
        </div>

        {notes[currentNoteIndex]?.photoBase64 && (
        <div className="snow-container">
          {explosionImages.map((piece) => (
            <img
              key={piece.id}
              src={`data:image/jpeg;base64,${notes[currentNoteIndex].photoBase64}`}
              alt=""
              className="snow-piece"
              style={{
                '--startX': `${piece.startX}px`,
                '--delay': `${piece.delay}s`,
                '--duration': `${piece.duration}s`,
                '--scale': piece.scale
              }}
            />
          ))}
        </div>
      )}
      </div>
  );
};

export default MemoryCarousel;